module.exports = "https://static.wmbcdn.com/uniweb/images/983bd60ecb58e76bd7db175f1e67f127.svg";